import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import Diensten from './pages/Diensten';
import Portfolio from './pages/Portfolio';
import Prijzen from './pages/Prijzen';
import Contact from './pages/Contact';
import Offerte from './pages/Offerte';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Voorwaarden from './pages/Voorwaarden';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/diensten" element={<Diensten />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/prijzen" element={<Prijzen />} />
          <Route path="/offerte" element={<Offerte />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/voorwaarden" element={<Voorwaarden />} />
        </Routes>
        <Footer />
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;
